"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.Authorization = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var button_1 = require("@atlaskit/button");
var TrelloPowerUpContext_1 = require("../contexts/TrelloPowerUpContext");
var tokens_1 = require("@atlaskit/tokens");
var Authorization = function (_a) {
    var heading = _a.heading, headingStyle = _a.headingStyle, imageSrc = _a.imageSrc, imageStyle = _a.imageStyle;
    var _b = (0, react_1.useContext)(TrelloPowerUpContext_1.TrelloPowerUpContext), authorize = _b.authorize, isAuthorizing = _b.isAuthorizing, appName = _b.appName, trelloIframe = _b.trelloIframe, isLoading = _b.isLoading;
    (0, react_1.useEffect)(function () {
        trelloIframe.updateModal({
            accentColor: (0, tokens_1.getTokenValue)('elevation.surface', '#ffffff')
        });
    }, [trelloIframe]);
    if (isLoading) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
            textAlign: 'center'
        } }, { children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    maxWidth: '420px',
                    maxHeight: '300px'
                } }, void 0), (0, jsx_runtime_1.jsx)("h1", __assign({ style: headingStyle }, { children: heading }), void 0), (0, jsx_runtime_1.jsx)("img", { src: imageSrc, style: imageStyle
                    ? imageStyle
                    : {
                        maxWidth: '420px',
                        maxHeight: '300px'
                    }, alt: heading }, void 0), (0, jsx_runtime_1.jsx)("p", { children: trelloIframe.localizeKey('to-get-started-authorize-this-power-up-with-trello') }, void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginTop: '8px' } }, { children: (0, jsx_runtime_1.jsx)(button_1.LoadingButton, __assign({ appearance: "primary", onClick: authorize, isLoading: isAuthorizing }, { children: trelloIframe.localizeKey('authorize-power-up', {
                        powerUpName: appName
                    }) }), void 0) }), void 0)] }), void 0));
};
exports.Authorization = Authorization;
//# sourceMappingURL=Authorization.js.map